import { useQuery } from '@tanstack/react-query';
import { FilterHorarios, Passagem } from '../../utils/interfaces';
import { api } from '../../libs/axios';
import { normalizePassagem } from '../../utils/normalizePassagem';

interface useProps {
  filter?: FilterHorarios
  contexto: 'ida'|'volta',
  active: number
}

async function getHorarios({ filter, contexto }: useProps): Promise<Passagem[]> {
    const response = await api.get('passagens/buscar', {
      params: {
        ...filter,
        contexto
      },
    });

    const passagens: Passagem[] = response.data.data
      .map(normalizePassagem)
      .filter((passagem: Passagem) => passagem.conexoes.length === 0);

    return passagens;
}

export function usePassagens({ filter, contexto, active }: useProps) {
  return useQuery({
    queryKey: ['passagens', {filter, contexto}],
    queryFn: typeof filter !== 'undefined' ? () => getHorarios({ filter, contexto, active }) : undefined,
    enabled: typeof filter !== 'undefined' && active === 0 ? true : false,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
